import { InputHasErrorProp, InputSizeVariantProp, baseStyles } from './styles'
import { FC, InputHTMLAttributes } from 'react'
import styled from 'styled-components'

const StyledInput = styled.input<InputHasErrorProp & InputSizeVariantProp>`
  ${baseStyles};
  line-height: ${(p) => (p.variant === 'small' ? '1.5rem' : '2rem')};
`

export interface InputProps
  extends InputHasErrorProp,
    InputSizeVariantProp,
    InputHTMLAttributes<HTMLInputElement> {}

export const Input: FC<InputProps> = ({ variant = 'regular', ...rest }) => (
  <StyledInput data-field-id={rest.name} variant={variant} {...rest} />
)
